import React, { useState, useEffect } from "react";
import FilterButton from "../../common-components/FilterButton";
import InputBox from "../../common-components/InputBox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useSearchParams } from "react-router-dom";
import useValidator from "../../utilities/useValidator";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader, showLoader } from "../../redux-store/loaderReducer";
import { communication } from "../../services/communication";
import Loader from "../../utilities/Loader";
import { genderArray } from "../../utilities/genderArray";
import { categoryArray } from "../../utilities/categoryArray";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const UpdateVoter = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParam] = useSearchParams();
  const loader = useSelector((state) => state.loaderReducer.loaderState);
  const [validator, showValidationMessage] = useValidator();
  const [electionList, setElectionList] = useState([]);
  const [voterData, setVoterData] = useState({
    name: "",
    mobile: "",
    gender: "",
    dob: new Date(),
    address: "",
    aadharNo: "",
    category: "",
    caste: "",
    bloodGroup: "",
    occupation: "",
    city: "",
    voterId: "",
    boothNo: "",
    boothName: "",
    panchayatSamiti: "",
    nagarParishad: "",
    zillaParishad: "",
    taluka: "",
    electionId: "",
  });

  // update Voters
  const updateVoter = async () => {
    try {
      if (!validator.allValid()) {
        showValidationMessage(true);
        return false;
      }
      dispatch(showLoader());
      const dataTosend = {
        ...voterData,
        id: searchParam.get("id"),
      };
      const responseFromServer = await communication.updateVoter(dataTosend);
      if (responseFromServer?.data?.status === "SUCCESS") {
        Swal.fire({ text: responseFromServer?.data?.message, icon: "success" });
        navigate("/dashboard/voter-data");
        dispatch(hideLoader());
      } else if (responseFromServer?.data?.status === "JWT_INVALID") {
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
      } else {
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      Swal.fire({
        text: error?.responseFromServer?.data?.message || error?.message,
        icon: "error",
      });
    }
  };
  // fetch voter detils by id
  const fetchvoterDetailById = async () => {
    try {
      dispatch(showLoader());
      const responseFromServer = await communication.getvoterDetailById(
        searchParam.get("id")
      );
      if (responseFromServer?.data?.status === "SUCCESS") {
        fetchElectionList();
        setVoterData(responseFromServer?.data?.voter);
        dispatch(hideLoader());
      } else if (responseFromServer?.data?.status === "JWT_INVALID") {
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
        navigate("/login");
      } else {
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      Swal.fire({
        text: error?.responseFromServer?.data?.message || error?.message,
        icon: "error",
      });
    }
  };

  //get all election list
  const fetchElectionList = async () => {
    try {
      const responseFromServer = await communication.getAllElectionList();
      if (responseFromServer?.data?.status === "SUCCESS") {
        setElectionList(responseFromServer?.data?.election);
      } else if (responseFromServer?.data?.status === "JWT_INVALID") {
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
        navigate("/login");
      } else {
        setElectionList([]);
      }
    } catch (error) {
      Swal.fire({
        text: error?.response?.data?.message || error?.message,
        icon: "error",
      });
    }
  };

  useEffect(() => {
    fetchvoterDetailById();
  }, []);

  return (
    <>
      {loader === true ? (
        <Loader />
      ) : (
        <>
          <div className="top_header">
            <div className="title">Update Voter</div>
          </div>
          <section>
            <div className="form_wrapper_main">
              <div className="card_wrapper">
                <div className="card_header">
                  <div className="title">
                    <h5>Upadate Voter</h5>
                  </div>
                  <div
                    className="close_button"
                    onClick={() => navigate("/dashboard/voter-data")}
                  >
                    <FontAwesomeIcon icon={faXmark} />
                  </div>
                </div>
                <div className="card_body">
                  <div className="row">
                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Full Name</label>
                        <InputBox
                          name="name"
                          value={voterData?.name}
                          onChange={(event) =>
                            setVoterData({
                              ...voterData,
                              name: event.target.value,
                            })
                          }
                          placeholder="Enter Full Name"
                        />
                        {validator.message("name", voterData.name, "required", {
                          messages: {
                            required: "Full Name is required",
                          },
                        })}
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Mobile Number</label>
                        <InputBox
                          name="mobile"
                          value={voterData?.mobile}
                          onChange={(event) =>
                            setVoterData({
                              ...voterData,
                              mobile:event.target.value,
                            })
                          }
                          placeholder="Enter Mobile Number"
                        />
                        {validator.message(
                          "mobile",
                          voterData.mobile,
                          "required|numeric|max:10",
                          {
                            messages: {
                              required: "Mobile Number is required",
                            },
                          }
                        )}
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Gender</label>
                        <div className="gender_input_wrapper">
                          {genderArray?.map((gender, index) => {
                            return (
                              <div className="gender_input" key={index}>
                                <input
                                  type="radio"
                                  name="gender"
                                  value={gender}
                                  checked={
                                    gender?.toLowerCase() ===
                                    voterData.gender?.toLowerCase()
                                  }
                                  onChange={(event) =>
                                    setVoterData({
                                      ...voterData,
                                      gender: event.target.value,
                                    })
                                  }
                                  className="form-check-input"
                                />
                                <label>{gender}</label>
                              </div>
                            );
                          })}
                        </div>
                        {validator.message(
                          "gender",
                          voterData.gender,
                          "required",
                          {
                            message: {
                              require: "Gender is Required",
                            },
                          }
                        )}
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Date of Birth</label>
                        <DatePicker
                          name="dob"
                          selected={new Date(voterData?.dob)}
                          placeholder="mm-dd-yy"
                          onChange={(event) =>
                            setVoterData({ ...voterData, dob: event })
                          }
                        />
                      </div>
                      {validator.message("dob", voterData.dob, "required", {
                        message: {
                          require: "Data of Birth is Required",
                        },
                      })}
                    </div>

                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Address</label>
                        <InputBox
                          name="address"
                          value={voterData?.address}
                          placeholder="Enter Address"
                          onChange={(event) =>
                            setVoterData({
                              ...voterData,
                              address: event.target.value,
                            })
                          }
                        />
                      </div>
                      {validator.message(
                        "address",
                        voterData.address,
                        "required",
                        {
                          message: {
                            require: "Address is Required",
                          },
                        }
                      )}
                    </div>

                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Blood Group</label>
                        <InputBox
                          name="bloodGroup"
                          value={voterData?.bloodGroup}
                          onChange={(event) =>
                            setVoterData({
                              ...voterData,
                              bloodGroup: event.target.value,
                            })
                          }
                          placeholder="Enter Blood Group"
                        />
                      </div>
                    </div>

                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Aadhar Card No</label>
                        <InputBox
                          name="aadharNo"
                          value={voterData?.aadharNo}
                          onChange={(event) =>
                            setVoterData({
                              ...voterData,
                              aadharNo: event.target.value,
                            })
                          }
                          placeholder="Enter Aadhar Card Number"
                        />
                      </div>
                    </div>

                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Category</label>
                        <select
                          onChange={(event) =>
                            setVoterData({
                              ...voterData,
                              category: event.target.value,
                            })
                          }
                          name="category"
                          className="form-select party_select_box"
                        >
                          <option value="">Select Category</option>
                          {categoryArray?.map((category, index) => {
                            return (
                              <option
                                value={category}
                                selected={category === voterData.category}
                                key={index}
                              >
                                {category}
                              </option>
                            );
                          })}
                        </select>
                        {validator.message(
                          "category",
                          voterData.category,
                          "required",
                          {
                            message: {
                              require: "Category is Required",
                            },
                          }
                        )}
                      </div>
                    </div>

                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Caste</label>
                        <InputBox
                          value={voterData?.caste}
                          onChange={(event) =>
                            setVoterData({
                              ...voterData,
                              caste: event.target.value,
                            })
                          }
                          name="cast"
                          placeholder="Enter Cast"
                        />
                        {validator.message(
                          "caste",
                          voterData.caste,
                          "required",
                          {
                            message: {
                              require: "Caste is Required",
                            },
                          }
                        )}
                      </div>
                    </div>

                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Occupation</label>
                        <InputBox
                          value={voterData?.occupation}
                          onChange={(event) =>
                            setVoterData({
                              ...voterData,
                              occupation: event.target.value,
                            })
                          }
                          name="occupation"
                          placeholder="Enter Occupation"
                        />
                        {validator.message(
                          "occupation",
                          voterData.occupation,
                          "required",
                          {
                            message: {
                              require: "occupation is Required",
                            },
                          }
                        )}
                      </div>
                    </div>

                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Village/City</label>
                        <InputBox
                          value={voterData?.city}
                          onChange={(event) =>
                            setVoterData({
                              ...voterData,
                              city: event.target.value,
                            })
                          }
                          name="city"
                          placeholder="Enter Village/City"
                        />
                        {validator.message("city", voterData.city, "required", {
                          message: {
                            require: "City/Village is Required",
                          },
                        })}
                      </div>
                    </div>

                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Voter ID</label>
                        <InputBox
                          value={voterData?.voterId}
                          onChange={(event) =>
                            setVoterData({
                              ...voterData,
                              voterId: event.target.value,
                            })
                          }
                          name="voterId"
                          placeholder="Enter Voter ID"
                        />
                        {validator.message(
                          "VoteId",
                          voterData.voterId,
                          "required",
                          {
                            message: {
                              require: "Voter Id is Required",
                            },
                          }
                        )}
                      </div>
                    </div>

                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Booth Name</label>
                        <InputBox
                          value={voterData?.boothName}
                          onChange={(event) =>
                            setVoterData({
                              ...voterData,
                              boothName: event.target.value,
                            })
                          }
                          name="boothName"
                          placeholder="Enter Booth Name"
                        />
                        {validator.message(
                          "booth Name",
                          voterData.boothName,
                          "required",
                          {
                            message: {
                              require: "Booth Name is Required",
                            },
                          }
                        )}
                      </div>
                    </div>

                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Booth Number</label>
                        <InputBox
                          value={voterData?.boothNo}
                          onChange={(event) =>
                            setVoterData({
                              ...voterData,
                              boothNo: event.target.value,
                            })
                          }
                          name="boothNumbar"
                          placeholder="Enter Booth Number"
                        />
                        {validator.message(
                          "Booth Number",
                          voterData.boothNo,
                          "required",
                          {
                            message: {
                              require: "Booth Number is Required",
                            },
                          }
                        )}
                      </div>
                    </div>

                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Page Number</label>
                        <InputBox
                          value={voterData?.pageNo}
                          onChange={(event) =>
                            setVoterData({
                              ...voterData,
                              pageNo: event.target.value,
                            })
                          }
                          name="pageNumber"
                          placeholder="Enter Page Number"
                        />
                        {validator.message(
                          "pageNo",
                          voterData.pageNo,
                          "required",
                          {
                            message: {
                              require: "Page Number is Required",
                            },
                          }
                        )}
                      </div>
                    </div>

                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Panchayat Samiti</label>
                        <InputBox
                          value={voterData?.panchayatSamiti}
                          onChange={(event) =>
                            setVoterData({
                              ...voterData,
                              panchayatSamiti: event.target.value,
                            })
                          }
                          name="panchayatSamiti"
                          placeholder="Enter Panchayat Samiti"
                        />
                      </div>
                    </div>

                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Nagar Parishad</label>
                        <InputBox
                          value={voterData?.nagarParishad}
                          onChange={(event) =>
                            setVoterData({
                              ...voterData,
                              nagarParishad: event.target.value,
                            })
                          }
                          name="nagarParishad"
                          placeholder="Enter Nagar Parishad"
                        />
                      </div>
                    </div>

                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Zilah Parishad</label>
                        <InputBox
                          value={voterData?.zillaParishad}
                          onChange={(event) =>
                            setVoterData({
                              ...voterData,
                              zillaParishad: event.target.value,
                            })
                          }
                          name="zilahParishad"
                          placeholder="Enter Zilah Parishad"
                        />
                      </div>
                    </div>

                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Tehsil</label>
                        <InputBox
                          value={voterData?.taluka}
                          onChange={(event) =>
                            setVoterData({
                              ...voterData,
                              taluka: event.target.value,
                            })
                          }
                          name="tehsil"
                          placeholder="Enter Tehsil"
                        />
                        {/* {validator.message("Tehsil", voterData.taluka, "requried", {
                          message: {
                            require: "Tehsil is Required"
                          }
                        })} */}
                      </div>
                    </div>

                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Election</label>
                        <select
                          name="election"
                          value={voterData?.electionId}
                          onChange={(event) =>
                            setVoterData({
                              ...voterData,
                              electionId: event.target.value,
                            })
                          }
                          className="form-select party_select_box"
                        >
                          <option value="">Select Election</option>
                          {electionList
                            ?.filter((ele) => ele.status === "new")
                            ?.map((electionDetail, index) => {
                              return (
                                <option
                                  value={electionDetail?._id}
                                  selected={
                                    electionDetail?._id === voterData.electionId
                                  }
                                  key={index}
                                >
                                  {electionDetail?.name}
                                </option>
                              );
                            })}
                        </select>
                        {validator.message(
                          "Election",
                          voterData.electionId,
                          "requried",
                          {
                            message: {
                              require: "Election is Required",
                            },
                          }
                        )}
                      </div>
                    </div>

                    <div className="submit_button_wrapper">
                      <FilterButton
                        name="Update"
                        onClick={() => updateVoter()}
                      ></FilterButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default UpdateVoter;
